var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"scale-transition"}},[(_vm.isMigrating)?_c('VAlert',{staticClass:"mb-0 mt-2",attrs:{"type":"info","icon":"fad fa-hourglass"}},[_vm._v("Migration, please wait few seconds...")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }